import { useToastStore } from '../store/toastStore';
import { X } from 'lucide-react';

const STYLES = {
  error: 'bg-destructive text-destructive-foreground',
  success: 'bg-green-600 text-white',
  info: 'bg-primary text-primary-foreground',
};

export function Toast() {
  const { message, type, clear } = useToastStore();
  if (!message) return null;

  return (
    <div
      role="alert"
      className={`fixed bottom-4 right-4 z-50 flex max-w-md items-start gap-3 rounded-lg px-4 py-3 shadow-lg ${STYLES[type]}`}
    >
      <p className="text-sm flex-1">{message}</p>
      <button type="button" onClick={clear} className="opacity-80 hover:opacity-100" aria-label="Dismiss">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
